module.exports = __webpack_public_path__ + "static/media/A1-7-Nergus-cod89.ced0dd32.png";